import { Box } from '@mui/material';
import CodeBox from 'components/CodeBox';

export type RoomE2EECodeProps = {
  roomCode: string[];
};

const RoomE2EECode = ({ roomCode }: RoomE2EECodeProps) => (
  <Box data-testid="code-box">
    <CodeBox>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4,minmax(0,1fr))',
          justifyItems: 'center',
          gap: 1,
        }}
      >
        {roomCode.map((chunk, i) => (
          <span key={i}>{chunk}</span>
        ))}
      </Box>
    </CodeBox>
  </Box>
);

export default RoomE2EECode;
